export const mapField = (fieldName, fieldMappings, defaultText) => {
    let mappedField = fieldMappings.find(fieldMapping => fieldMapping.field_name === fieldName);

    return mappedField
        ? mappedField.translation
        : defaultText;
};



// WEBPACK FOOTER //
// ./src/Assets/components/FieldMappings/filters/mapField.js